<div
  [style]="componentOuterStyle"
  [ngClass]="{ 'report-text-vertical': !reportText.isHorizontal }"
  [style.z-index]="reportText.zIndex"
  [style.top]="verticalTop"
  [style.left]="reportText.left"
  [style.max-width]="reportText.isHorizontal ? reportText.width : reportText.height"
  [style.max-height]="reportText.isHorizontal ? reportText.height : reportText.width"
>
  <div
    [style]="reportTextStyle"
    [style.z-index]="reportText.zIndex"
    [style.width]="reportText.isHorizontal ? reportText.width : reportText.height"
    [style.height]="reportText.isHorizontal ? reportText.height : reportText.width"
  >
    <div
      [style]="reportTextInlineStyle"
      [style.color]="reportText.color"
      [style.font-size]="reportText.fontSize"
      [style.font-family]="reportText.fontFamily"
      [style.font-style]="reportText.fontStyle"
      [style.font-weight]="reportText.fontWeight"
      [style.text-align]="reportText.textAlign"
      [style.line-height]="reportText.lineHeight"
      [style.background-color]="reportText.backgroundColor"
      [style.justify-content]="reportText.justifyContent"
      [style.width]="reportText.isHorizontal ? reportText.width : reportText.height"
      [style.height]="reportText.isHorizontal ? reportText.height : reportText.width"
      [style.align-items]="reportText.alignItems"
      [style.vertical-align]="reportText.verticalAlign"
      [style.padding-left]="reportText.paddingLeft"
      [style.padding-right]="reportText.paddingRight"
      [style.padding-top]="reportText.paddingTop"
      [style.padding-bottom]="reportText.paddingBottom"
      [style.border-style]="reportText.borderStyle"
      [style.border-width]="reportText.borderWidth"
      [style.border-color]="reportText.borderColor"
    >
      {{ text }}
    </div>
  </div>
</div>
